import { BOOKING_HOUR_TO_AFTERNOON, BOOKING_HOUR_TO_MORNING } from '@yescapa-dev/ysc-api-js/modern'
import type { HourTo } from '@yescapa-dev/ysc-api-js/modern'

export function assertHourTo(x: unknown): asserts x is HourTo {
  if (x === BOOKING_HOUR_TO_MORNING || x === BOOKING_HOUR_TO_AFTERNOON) {
    return
  }
  throw new Error('unvalid hour to')
}
